
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("hBGZx", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $cd173d93dc9d9796$export$2cd8252107eb640b; });
// ====================================================================================
// readMoreMarker.module
// ====================================================================================

var $jG4hL = parcelRequire("jG4hL");
const $cd173d93dc9d9796$export$2cd8252107eb640b = ()=>{
    // read-more Klapperfunktion mit ###weiterlesen### marker
    let readMores = document.querySelectorAll(".read-more-marker");
    let headerHeight = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".header").height();
    readMores.forEach((readMore)=>{
        let $readMoreMarker = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(readMore);
        let $readMoreText = $readMoreMarker.nextAll();
        let offsetTop = $readMoreMarker.offset().top - headerHeight - 100;
        $readMoreMarker.html('<div class="text-center">\n    <button class="btn btn--more" title="weiterlesen">\n            <span>&hellip;</span><span>weiterlesen</span>\n    </button>\n</div>');
        $readMoreText.hide();
        $readMoreMarker.parent().append('<div class="read-less-marker"><div class="text-center">\n    <button class="btn btn--more" title="weniger anzeigen">\n            <span>&hellip;</span><span>weniger anzeigen</span>\n    </button>\n</div></div>');
        $readMoreMarker.parent().find(".read-less-marker").hide();
        //$('.read-more').parent().nextAll().css( "background-color", "red" );
        $readMoreMarker.on("click", function() {
            $readMoreText.slideDown();
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).hide();
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).parent().parent().find(".read-less-marker").show();
        });
        $readMoreMarker.parent().find(".read-less-marker").on("click", function(e) {
            let $this = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this);
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("html, body").animate({
                scrollTop: offsetTop
            }, 400);
            $readMoreText.slideUp(400, function() {
                $this.hide();
                $this.parent().find(".read-more-marker").show();
            });
        });
    });
};

});


//# sourceMappingURL=readMoreMarker.module.100b2c23.js.map
